import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/40_card_back_castle/40_card_back_castle"
 * Contains 1 texture(s)
 */
export class CardsBacks40CardBackCastleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/40_card_back_castle/40_card_back_castle';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '40_castle.png'
    ] as const;
}
